exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reserve-list[data-v-78c497a2]{background-color:#f0f0f0;height:100%}.reserve-list-container[data-v-78c497a2]{padding:20px;width:100%}", ""]);

// exports
